import datePicker from './bs4-datepicker';
import TitleNavbar from './../components/layout/TitleNavBar';
import DashboardTile from './../components/layout/DashboardTile';
import Card from './../components/layout/Card';
import DataTable from './../components/common/DataTable';
import GoogleAutoComplete from './../components/common/GoogleAutoComplete';
import SkilloChart from './../components/common/SkilloChart';
import AddToCalendar from 'vue-add-to-calendar';
import JsonExcel from 'vue-json-excel';

import FullCalendar from './fullcalendar';

import 'fullcalendar';
import 'fullcalendar/dist/locale/it'
import 'fullcalendar/dist/fullcalendar.min.css'
import 'vue-multiselect/dist/vue-multiselect.min.css';


const Components = {};

Components.install = function (Vue) {
  Vue.component('TitleNavbar', TitleNavbar);
  Vue.component('DashboardTile', DashboardTile);
  Vue.component('Card', Card);
  Vue.component('DataTable', DataTable);
  Vue.component('GoogleAutocomplete', GoogleAutoComplete);
  Vue.component('Datepicker', datePicker);
  Vue.component('SkilloChart', SkilloChart);
  Vue.component('FullCalendar', FullCalendar);
  Vue.component('downloadExcel', JsonExcel);
  Vue.use(AddToCalendar);
};

export default Components;



// WEBPACK FOOTER //
// ./src/plugins/vue-components.js